import { createContext } from 'react'

export interface HubspotConversationsContextType {
  toggleWidget: () => void
  isOpen: boolean
  unreadMessagesCount: number
}

export const HubspotConversationsContext = createContext<HubspotConversationsContextType | null>(null)
